// extracted by mini-css-extract-plugin
export var audioPlayer = "_s7-0";